import { IonProgressBar, IonRippleEffect } from "@ionic/react";
import React from "react";
import "./SyncStatusProgressBar.css";
import { ReplicatorStatus } from "../models/ReplicatorStatus";
import SessionExpiryModal from "./SessionExpiryModal";

const CB_HTTP_AUTH_REQUIRED_ERROR_CODE = 10401;

interface Props {
    currentSyncStatus: ReplicatorStatus;
    lastSessionExpiryAlertTime: Date | null;
    onTryToConnect: () => void;
    onReLogin: () => void;
    onCloseSessionExpiryAlert: () => void;
}

const SyncStatusProgressBar: React.FC<Props> = ({
    currentSyncStatus,
    lastSessionExpiryAlertTime,
    onTryToConnect,
    onReLogin,
    onCloseSessionExpiryAlert,
}) => {
    var authenticationRequired = currentSyncStatus.error?.code === CB_HTTP_AUTH_REQUIRED_ERROR_CODE;
    var showSessionExpiryAlert = authenticationRequired && lastSessionExpiryAlertTime == null;

    const currentStatus = currentSyncStatus.activityLevel?.toUpperCase();
    var color = "Primary";
    var type: "determinate" | "indeterminate" = "determinate";

    switch (currentStatus) {
        case "INITIAL":
            color = "medium";
            type = "indeterminate";
            break;
        case "RUNNING":
        case "BUSY":
            color = "primary";
            type = "indeterminate";
            break;
        case "IDLE":
            color = "success";
            break;
        case "OFFLINE":
        case "STOPPING":
        case "STOPPED":
            color = "warning";
            break;
    }

    if (currentStatus === "IDLE") return null;
    const disconnect = ["OFFLINE", "STOPPING", "STOPPED"];

    return (
        <>
            {authenticationRequired && (
                <div className="wrapper" onTouchStart={onReLogin}>
                    <div className="ion-activatable ripple-parent custom-parent">
                        Exit & login again now
                        <IonRippleEffect className="custom-ripple"></IonRippleEffect>
                    </div>
                </div>
            )}

            {!authenticationRequired && disconnect.includes(currentStatus) && (
                <div className="wrapper" onTouchStart={onTryToConnect}>
                    <div className="ion-activatable ripple-parent custom-parent">
                        Try to connect
                        <IonRippleEffect className="custom-ripple"></IonRippleEffect>
                    </div>
                </div>
            )}

            <IonProgressBar color={color} type={type}></IonProgressBar>

            <SessionExpiryModal
                isOpen={showSessionExpiryAlert}
                onReLogin={onReLogin}
                onContinue={onCloseSessionExpiryAlert}
            />
        </>
    );
};

export default SyncStatusProgressBar;
